import { useScrollProgress } from '../hooks';
import { C } from '../config/constants';

export default function ScrollProgressBar() {
  const progress = useScrollProgress();

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, height: '3px',
      zIndex: 1300, pointerEvents: 'none',
    }}>
      <div className="scroll-progress-fill" style={{
        height: '100%', width: `${progress}%`,
        background: `linear-gradient(90deg, ${C.blau}, ${C.groc})`,
      }}/>
    </div>
  );
}